import React from 'react';
import { Box, Typography, Link, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';

const FooterWrapper = styled(Box)(({ backgroundColor, borderColor }) => ({
  width: '100%',
  backgroundColor: backgroundColor || '#f8fafc',
  borderTop: borderColor ? `1px solid ${borderColor}` : '1px solid #e2e8f0',
  padding: '10px 16px',
  textAlign: 'center'
}));

const FooterText = styled(Typography)(() => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '18px',
  fontWeight: 700,
  color: '#64748b'
}));

const FooterTextLight = styled(FooterText)(() => ({
  color: '#ffffff'
}));

const FooterLink = styled(Link)(() => ({
  color: '#0b91d6',
  fontWeight: 600,
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline'
  }
}));

const FooterLinkLight = styled(FooterLink)(() => ({
  color: '#ffffff'
}));

const FooterRow = styled(Stack)(() => ({
  alignItems: 'center',
  justifyContent: 'center',
  flexWrap: 'wrap',
  gap: '8px'
}));

const SocialIcons = styled(Stack)(() => ({
  flexDirection: 'row',
  gap: '10px'
}));

const SocialIconLink = styled(Link)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '44px',
  height: '44px',
  borderRadius: '12px',
  backgroundColor: '#e2e8f0',
  color: '#64748b',
  textDecoration: 'none',
  transition: 'all 0.2s ease',
  '&:hover': {
    backgroundColor: '#0EA5E9',
    color: '#ffffff'
  }
}));

const SocialIconLinkLight = styled(SocialIconLink)(() => ({
  backgroundColor: 'rgba(255, 255, 255, 0.2)',
  color: '#ffffff',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.35)',
    color: '#ffffff'
  }
}));

const VisibeenFooter = ({ backgroundColor, borderColor, variant = 'light' }) => {
  const TextComponent = variant === 'dark' ? FooterTextLight : FooterText;
  const LinkComponent = variant === 'dark' ? FooterLinkLight : FooterLink;
  const SocialLinkComponent = variant === 'dark' ? SocialIconLinkLight : SocialIconLink;

  return (
    <FooterWrapper backgroundColor={backgroundColor} borderColor={borderColor}>
      <FooterRow direction={{ xs: 'column', sm: 'row' }}>
        <TextComponent>
          Powered by <LinkComponent href="https://visibeen.com" target="_blank" rel="noreferrer">Visibeen</LinkComponent>
        </TextComponent>
        <SocialIcons>
          <SocialLinkComponent href="https://www.instagram.com/visibeen/" target="_blank" rel="noopener noreferrer" aria-label="Visibeen Instagram">
            <InstagramIcon fontSize="large" />
          </SocialLinkComponent>
          <SocialLinkComponent href="https://www.facebook.com/profile.php?id=61566867428338" target="_blank" rel="noopener noreferrer" aria-label="Visibeen Facebook">
            <FacebookIcon fontSize="large" />
          </SocialLinkComponent>
          <SocialLinkComponent href="https://www.linkedin.com/company/visibeen/" target="_blank" rel="noopener noreferrer" aria-label="Visibeen LinkedIn">
            <LinkedInIcon fontSize="large" />
          </SocialLinkComponent>
          <SocialLinkComponent href="https://www.youtube.com/@Visibeen" target="_blank" rel="noopener noreferrer" aria-label="Visibeen YouTube">
            <YouTubeIcon fontSize="large" />
          </SocialLinkComponent>
        </SocialIcons>
      </FooterRow>
    </FooterWrapper>
  );
};

export default VisibeenFooter;
